import * as React from 'react'
import './sub-header.css'


export default class extends React.Component<any, any>{

    render(){
        if(this.props.show ==null || this.props.show == true){
            return(
                <div className="sub-sub-header col-12">
                    <h5>{ this.props.children }</h5>
                </div>
            )
        }else{
            return false;
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/sub-sub-header.tsx